<div class="license" [ngClass]="{'license--overdue': !!licensesData.sanction}">
  <div class="license__wrap ">
    <div class="license__head "
      [ngClass]="{
        ' button-show': !licensesData.sanction && usingAspect === 'DASHBOARD' && (!toRenewLicense() && licensesLength > 1 ),
        ' head-sanctioned': !!licensesData.sanction
      }"
      (click)="usingAspect === 'DASHBOARD' && (!toRenewLicense() && licensesLength > 1 && !isMobile ) ? toggle() : ''">
      <div class="head__content" *ngIf="!licensesData.sanction">
        <div class="head__location">
          <h4>{{licensesData.asset?.name}}</h4>
        </div>
        <div class="head__number">
          <h4> Nº: {{licensesData.licenseNumber}} <img
              *ngIf="usingAspect === 'DASHBOARD' && (!toRenewLicense() && licensesLength > 1)"
              [@openLicense]="arrowState0 " class="arrow-head" src="assets/img/arrow_g_d.png"></h4>
        </div>
      </div>

      <div class="head__content" *ngIf="licensesData.sanction">
        <div class="head__location">
          <h4>{{ licensesData.asset?.name }}</h4>
          <h4><span>Licencia</span> Nº {{ licensesData?.licenseNumber }} </h4>
        </div>
        <div class="head__status">
          <h3 class="h3-sanction">
            <img src="assets/img/vencida.png" alt="">
            <span *ngIf="isSuspended(licensesData?.sanction?.sanctionType)">
              LICENCIA {{ licensesData?.sanction?.sanctionType | uppercase }}
            </span>
            <span *ngIf="!isSuspended(licensesData?.sanction?.sanctionType)">
              LICENCIA CON {{ licensesData?.sanction?.sanctionType | uppercase }}
            </span>
          </h3>
          <p class="p-sanction">
            <span *ngIf="!isSuspended(licensesData?.sanction?.sanctionType)">Tipo:
              {{ licensesData?.sanction?.severityType | titlecase }} | </span>
            <span *ngIf="licensesData?.sanction?.dateEndAt"> Desde el
              {{ licensesData?.sanction?.dateStartAt | dateFromBack }} hasta el
              {{ licensesData?.sanction?.dateEndAt | dateFromBack }} </span>
            <span *ngIf="!licensesData?.sanction?.dateEndAt"> Desde el
              {{ licensesData?.sanction?.dateStartAt | dateFromBack }} hasta indefinido </span>
          </p>
        </div>
      </div>

      <div class="head__pdf">
        <!-- <button (click)="downloadPdfsInAZip(licensesData?.id!, licensesData.licenseNumber!)" style="text-align: center;"
          class="btn btn--link btn--link--secondary">
          <img class="mr-1" src="assets/img/down_g.png">
          Archivo zipp
        </button> -->
        <button (click)="downloadPocketLicence(licensesData?.id!)" class="btn btn--link btn--link--secondary" style="text-align: center;"><img
            class="mr-1" src="assets/img/down_g.png">Tipo
          credencial</button>
        <button (click)="downloadLicence(licensesData?.id!)" class="btn btn--link btn--link--secondary" style="text-align: center;"><img
            class="mr-1" src="assets/img/down_g.png"> PDF -
          Completa</button>
      </div>
    </div>
    <div class="license__content" [@openLicense]="(usingAspect === 'DASHBOARD') ? ( !!licensesData.sanction ? 'open' : menuState0 ) : ''">
      <div class="content__info">
        <div class="content__employee">
          <img class="user rounded-circle width-repaired" [src]="sanitizedBase64Image" alt="">
          <div class="employee__info" *ngIf="_userData">
            <h5> {{_userData.fullName}} </h5>
            <p>{{_userData.rutDv ? (_userData?.rutDv | parseRut) :  _userData.passport}}</p>
          </div>
          <img class="qr bigger-qr " [src]="qrImage" alt="">
        </div>
        <div class="content__retriccion restriction-fix-css restrictionAndMunicipalLicenses">
          <div class="col-md-6">
            <h5>Restricciones de conducción:</h5>
            <p> {{licensesData.asset?.drivingRestriction || 'No se declaran restricciones.'}} </p>
          </div>
          <div class="col-md-6">
            <h5>Licencias municipales:</h5>
            <p>{{(licensesData.municipalLicenses || []) | separatedByCharacter: [', ', ' y '] }} </p>
          </div>
        </div>
        <div class="content__pdf">
          <div class="pdf__button">
            <div>
              <p class="mb-1">Descarga tu licencia</p>
            </div>
            <!-- <div>
              <a
                (click)="downloadPdfsInAZip(licensesData?.id!, licensesData.licenseNumber!)"
                class="btn btn--link btn--link--secondary btn--link--secondary--icon p-0 u-mb10"
              >
                <div *ngIf="isCurrentlyDownloading(licensesData?.id! + '-Z')" class="loader-container">
                  <app-loader></app-loader>
                </div>
                 <img
                  src="assets/img/down_g.png" class="correct-download-img-position" alt="">Archivo Zip
              </a>
            </div> -->
            <div><a (click)="downloadPocketLicence(licensesData?.id!)"
                class="btn btn--link btn--link--secondary btn--link--secondary--icon p-0 u-mb10">
                <div *ngIf="isCurrentlyDownloading(licensesData?.id! + '-P')" class="loader-container">
                  <app-loader></app-loader>
                </div>
                <img
                  src="assets/img/down_g.png" class="correct-download-img-position" alt="">Tipo credencial</a></div>
            <div><a (click)="downloadLicence(licensesData?.id!)"
                class="btn btn--link btn--link--secondary btn--link--secondary--icon p-0">
                <div *ngIf="isCurrentlyDownloading(licensesData?.id! + '-C')" class="loader-container">
                  <app-loader></app-loader>
                </div>
                <img
                  src="assets/img/down_g.png" class="correct-download-img-position" alt="">PDF - Completa</a></div>
          </div>
          <div> <img class="qr bigger-qr" [src]="qrImage" alt=""></div>

        </div>
      </div>
      <div class="table table--license license-cont">
        <div class="thead">
          <div class="tr">
            <div class="th">Estado</div>
            <div class="th"><img class="mr-2" src="assets/img/truck.png">Vehículos registrados</div>
            <div class="th"><img class="mr-2" src="assets/img/local.png">Zonas registradas</div>
            <div class="th"><img class="mr-2" src="assets/img/card_g.png">Lic. municipal requerida</div>
            <div class="th"><img class="mr-2" src="assets/img/cal_g.png">Vencimiento</div>
            <div class="th"><img class="mr-2" src="assets/img/type_driver.png">Tipo licencia</div>
          </div>
        </div>
        <div class="tbody">
          <div class="tr" [ngClass]="changeColorByClass(vehicle.equipmentStatus)"
            *ngFor="let vehicle of licensesData?.equipments;index as vi;"
            (click)=" usingAspect === 'EXTEND_LICENSE' && (selectedOption === 'LICENSE_TYPE' || selectedOption === 'ZONE') ? onSelectEquipmentToEdit(vehicle) : ''">
            <div class="td td--number"
              [ngClass]="{'selectedEquipment': vi === selectedVehicleIndex && (selectedOption === 'LICENSE_TYPE' || selectedOption === 'ZONE')}">
              <p>{{vehicle.equipmentStatus | firstToUpperinPhrase}}</p>
            </div>

            <div class="td td--button" (click)="toggleVehicle(vi)">
              <div>
                <img class="mr-2" src="assets/img/truck.png">
              </div>
              <div>
                <p>{{vehicle.equipmentName }}</p>
                <small>{{vehicle.equipmentBrand }} -
                  {{vehicle.equipmentModel }}</small>
                <img [@openLicense]="arrowState0 " class="vehicle-arrow "
                  [ngClass]="showVehicles[vi] ? 'opened-vehicle' : '' " src="assets/img/arrow_g_d.png">
              </div>
            </div>

            <div
              [ngClass]="!showVehicles[vi] ? 'animation-container--closed td td--body ': 'animation-container td td--body' "
              class=" max-width-zones-rows ">
              <div>
                <img class="mr-2" src="assets/img/local.png">
              </div>
              <div>

                <ul *ngFor="let item of counter(zonesRows[licenseIndex][vi]) as rows;index as rowIndex">
                  <li *ngFor="let zones of vehicle.conductionZones | slice: rowIndex*2: (rowIndex*2)+2 ">
                    {{zones}}
                  </li>

                </ul>

                <div class=" u-mt10 mineComment" *ngIf="vehicle.note">
                  {{ vehicle.note }}
                </div>
              </div>

            </div>

            <div
              [ngClass]="!showVehicles[vi] ? 'animation-container--closed td td--body ': 'animation-container td td--body' ">
              <div>
                <img class="mr-2" src="assets/img/card_g.png">
              </div>
              <div>
                <p>{{vehicle.municipalLicenses | separatedByCharacter: [', ', ' y '] }} </p>
              </div>
            </div>

            <div
              [ngClass]="!showVehicles[vi] ? 'animation-container--closed td td--body ': 'animation-container td td--body' ">
              <div>
                <img class="mr-2" src="assets/img/cal_g.png">
              </div>
              <div>
                <p>{{ vehicle.expiredAt | dateFromBack }}</p>
              </div>
            </div>

            <div class="width-typeLicense"
              [ngClass]="!showVehicles[vi] ? 'animation-container--closed td td--body ': 'animation-container td td--body' ">
              <div>
                <img class="mr-2" src="assets/img/type_driver.png">
              </div>
              <div>
                <p> {{vehicle.licenseTypes | separatedByCharacter: [', ', ' y '] }} </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
